import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import {  Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState , useEffect} from "react";
import { Search, SentimentDissatisfied } from "@mui/icons-material";

const Header= ({children, onLandingPage})=>{

const navigate = useNavigate();


    return(
        <Box className="header">
        <Box className="header-title" onClick={()=>{ navigate('/')}} sx={{ "&:hover": { cursor: "pointer" } }}>
            <span style={{color:" #EE1520", fontWeight:"400px", fontFamily:"Roboto Condensed" , margin:"0",fontSize:"1.5rem"}}>X{" "} </span>
            <span style={{color:"#ffffff",fontWeight:"400px", fontFamily:"Roboto" ,margin:"0", fontSize:"1.5rem"}}>{" "}Flix</span>
        </Box>
    
       {children}
       
      </Box>
    );

};
export default Header;